export function getLoginURL(locale: string): string {
    if (process.env.REACT_APP_OLV2_LINK) {
        return process.env.REACT_APP_OLV2_LINK + "?culture=" + locale;
    } else {
        return "https://saifonline.saif.com/onlineloginv2/login?culture=" + locale;
    }
};